import React, { Component } from "react";
import axios from "axios";
import { admission, arit, mua } from "../config/api";

import MetaTags from "react-meta-tags";
import Swal from "sweetalert2";
import { HiDocumentText } from "react-icons/hi";
import {
  HiOutlineBanknotes,
  HiOutlineDocumentDuplicate,
  HiOutlinePhone,
} from "react-icons/hi2";
import present1 from "../assets/present2569/1.png";
import present2 from "../assets/present2569/2.png";
import present3 from "../assets/present2569/3.png";
import present4 from "../assets/present2569/4.png";
import present5 from "../assets/present2569/5.png";
import present6 from "../assets/present2569/6.png";
import present7 from "../assets/present2569/7.png";
import present8 from "../assets/present2569/8.png";
import present9 from "../assets/present2569/9.png";
import present10 from "../assets/present2569/10.png";
import present11 from "../assets/present2569/11.png";
import present12 from "../assets/present2569/12.png";
import present13 from "../assets/present2569/13.png";
import present14 from "../assets/present2569/14.png";
import present15 from "../assets/present2569/15.png";
import present16 from "../assets/present2569/16.png";
import present17 from "../assets/present2569/17.png";
import present18 from "../assets/present2569/18.png";
import present19 from "../assets/present2569/19.png";
import present20 from "../assets/present2569/20.png";
import present21 from "../assets/present2569/21.png";
import present22 from "../assets/present2569/22.png";
import present23 from "../assets/present2569/23.png";
import present24 from "../assets/present2569/24.png";
import present25 from "../assets/present2569/25.png";
import present26 from "../assets/present2569/26.png";
import present27 from "../assets/present2569/27.png";
import "./Checkregister.css";
import "./Checkpresent.css";

const PRESENT_GUIDE_IMAGES = [
  present1,
  present2,
  present3,
  present4,
  present5,
  present6,
  present7,
  present8,
  present9,
  present10,
  present11,
  present12,
  present13,
  present14,
  present15,
  present16,
  present17,
  present18,
  present19,
  present20,
  present21,
  present22,
  present23,
  present24,
  present25,
  present26,
  present27,
];
export default class Checkpresent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      citizent: "",
      checkpaymoney: false,
      screenWidth: 0,
      screenHieght: 0,
      present: false,
      load: false,
      // pathreturn: "http://localhost:3000/admission",
      pathreturn: window.location.origin,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkpaymoney_close = this.checkpaymoney_close.bind(this);
    this.CheckDatePresent = this.CheckDatePresent.bind(this);
    this.submitpresent2025 = this.submitpresent2025.bind(this);
    this.checkpdpa = this.checkpdpa.bind(this);
  }
  redirectToDataRegister = (item) => {
    // ใช้ history.push เพื่อเปลี่ยนเส้นทาง
    window.location.href = this.state.pathreturn + item;
  };
  CheckDatePresent() {
    const starts = "2025-04-01 00:00";
    const start = new Date(starts);
    const stops = "2025-04-30 16:40";
    const stop = new Date(stops);
    // console.log(start)
    // console.log(stop)
    const date = new Date();
    // console.log(date)
    if (date >= start && date <= stop) {
      /// true เท่ากับเปิด
      this.setState({ present: true });
    } else {
      // console.log("ปิด")
      /// false เท่ากับปิด
      // this.setState({ present: false });
      this.setState({ present: true });
    }
  }
  componentDidMount() {
    localStorage.clear();
    this.CheckDatePresent();
    if (window.screen.width < 500) {
      this.setState({ screenWidth: "100%" });
    } else {
      this.setState({ screenWidth: window.screen.width * 0.3 });
    }
    this.setState({ screenHieght: window.screen.height });
  }

  handleChange(event) {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    const citizent = this.state.citizent.replace("/", ",");
    this.setState({ citizent });
    axios
      .get(mua + "/admissionnew2022/showlistregister?id=" + encodeURIComponent(citizent))
      .then((res) => {
        const nested = res?.data?.data;
        const list = Array.isArray(nested?.data)
          ? nested.data
          : Array.isArray(nested)
            ? nested
            : [];

        if (list.length !== 0) {
          res.data = { data: { data: list } };
          // Swal.fire({
          //   icon: "success",
          //   title: "ยินดีต้อนรับ",
          //   timer:1500,
          //   timerProgressBar:true,
          //   showConfirmButton:false
          // }).then((res)=>{
          // Swal.fire({
          //   icon:'info'
          // }).then((res)=>{

          // })
          res.data.data.data = res.data.data.data.filter(
            ({ REGISTER_STATUS }) =>
              !(
                REGISTER_STATUS === "11" ||
                REGISTER_STATUS === "91" ||
                REGISTER_STATUS === "12" ||
                REGISTER_STATUS === "5" ||
                REGISTER_STATUS === "41"||
                REGISTER_STATUS === "4"
              )
          );
          if (!res.data.data.data.length) {
            Swal.fire({
              icon: "info",
              title: "ไม่พบข้อมูลของ : " + citizent,
            });
            return;
          }
          // res.data.data.data = res.data.data.data.filter(({ REGISTER_STATUS }) => parseInt(REGISTER_STATUS) >= 4 );
          // console.log(res.data.data.data);
          if (
            res.data.data.data[0]["REGISTER_STATUS"] === "0" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "1" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "2" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "3" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "4" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "5" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "12"
          ) {
            localStorage.setItem("citizent", citizent);
            localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
            // localStorage.setItem("statusHeader", "1");
            localStorage.setItem("statustitle", "ตรวจสอบสถานะ");
            axios
              .get(
                arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                citizent +
                "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
              )
              .then((checkdata) => {
                if (checkdata.data.length !== 0) {
                  Swal.fire({
                    icon: "success",
                    title: "ยินดีต้อนรับ",
                    timer: 1500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                  }).then((res) => {
                    window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
                  });
                } else {
                  Swal.fire({
                    icon: "success",
                    title: "ยินดีต้อนรับ",
                    timer: 1500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                  }).then((res) => {
                    window.location.href =
                      arit + "/ap/account/?nu=pdpaAgree&code=" +
                      btoa(citizent) +
                      "&status=" +
                      btoa(3) +
                      "&url=" +
                      btoa(window.location.origin + (process.env.REACT_APP_BASENAME || "") + "/Dataregister");
                  });
                }
                // }
              });
          } else if (
            res.data.data.data[0]["REGISTER_STATUS"] === "6" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "7" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "8" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "9"
          ) {
            if (res.data.data.data[0]["REGISTER_TYPE_ID"] === "6") {
              localStorage.setItem("citizent", citizent);
              localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
              localStorage.setItem("statusHeader", "1");
              axios
                .get(admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"])
                .then((response) => {
                  if (response.data === 0) {
                    axios
                      .get(
                        arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          Swal.fire({
                            icon: "success",
                            title: "ยินดีต้อนรับ",
                            timer: 1500,
                            timerProgressBar: true,
                            showConfirmButton: false,
                          }).then((res) => {
                            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/admission/Present`;
                          });
                        } else {
                          Swal.fire({
                            icon: "success",
                            title: "ยินดีต้อนรับ",
                            timer: 1500,
                            timerProgressBar: true,
                            showConfirmButton: false,
                          }).then((res) => {
                            window.location.href =
                              arit + "/ap/account/?nu=pdpaAgree&code=" +
                              btoa(citizent) +
                              "&status=" +
                              btoa(3) +
                              "&url=" +
                              btoa(window.location.origin + (process.env.REACT_APP_BASENAME || "") + "/admission/Present");
                          });
                        }
                      });
                  } else {
                    axios
                      .get(
                        arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          Swal.fire({
                            icon: "success",
                            title: "ยินดีต้อนรับ",
                            timer: 1500,
                            timerProgressBar: true,
                            showConfirmButton: false,
                          }).then((res) => {
                            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/admission/Present`;
                          });
                        } else {
                          Swal.fire({
                            icon: "success",
                            title: "ยินดีต้อนรับ",
                            timer: 1500,
                            timerProgressBar: true,
                            showConfirmButton: false,
                          }).then((res) => {
                            window.location.href =
                              arit + "/ap/account/?nu=pdpaAgree&code=" +
                              btoa(citizent) +
                              "&status=" +
                              btoa(3) +
                              "&url=" +
                              btoa(window.location.origin + (process.env.REACT_APP_BASENAME || "") + "/admission/Present");
                          });
                        }
                      });
                  }
                });
            } else if (
              res.data.data.data[0]["REGISTER_TYPE_ID"] === "2" ||
              res.data.data.data[0]["REGISTER_TYPE_ID"] === "3"
            ) {
              localStorage.setItem("citizent", this.state.citizent);
              localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
              // if (this.state.present === true) {

              // } else {
              //   // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
              // }

              // เปิดตอนช่วงรายงานตัว
              localStorage.setItem("statusHeader", "1");
              axios
                .get(admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"])
                .then((response) => {
                  if (response.data === 0) {
                    axios
                      .get(
                        arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          window.location.href = `${process.env.REACT_APP_BASENAME || ""}/admission/Present`;
                        } else {
                          window.location.href =
                            arit + "/ap/account/?nu=pdpaAgree&code=" +
                            btoa(this.state.citizent) +
                            "&status=" +
                            btoa(3) +
                            "&url=" +
                            btoa(window.location.origin + (process.env.REACT_APP_BASENAME || "") + "/admission/Present");
                        }
                      });
                  } else {
                    axios
                      .get(
                        arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          window.location.href = `${process.env.REACT_APP_BASENAME || ""}/admission/Present`;
                        } else {
                          window.location.href =
                            arit + "/ap/account/?nu=pdpaAgree&code=" +
                            btoa(this.state.citizent) +
                            "&status=" +
                            btoa(3) +
                            "&url=" +
                            btoa(window.location.origin + (process.env.REACT_APP_BASENAME || "") + "/admission/Present");
                        }
                      });
                  }
                });
            } else {
              localStorage.setItem("citizent", this.state.citizent);
              localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
              // Swal.fire({
              //   text: this.state.pathreturn + "/Present",
              // }).then((res) => {
              // });
              // return 0;
              if (this.state.present === true) {
              } else {
                // window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
              }

              if (
                // res.data.data.data[0]["Major1_MAJOR_ID"] === "9902" ||
                res.data.data.data[0]["Major1_MAJOR_ID"] === "9903" ||
                res.data.data.data[0]["Major1_MAJOR_ID"] === "9901"
              ) {
                if (
                  res.data.data.data[0]["REGISTER_STATUS_BILL_ROB1_BOOK"] ||
                  res.data.data.data[0]["REGISTER_STATUS_BILL_ROB2_BOOK"] ||
                  res.data.data.data[0]["REGISTER_STATUS_BILL_ROBFULL_BOOK"]
                ) {
                  localStorage.setItem("statusHeader", "1");
                  axios
                    .get(
                      admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]
                    )
                    .then((response) => {
                      if (response.data === 0) {
                        axios
                          .get(
                            arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = this.state.pathreturn + "/admission/Present";
                            } else {
                              window.location.href =
                                arit + "/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(this.state.pathreturn + "/admission/Present");
                            }
                          });
                      } else {
                        axios
                          .get(
                            arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = this.state.pathreturn + "/admission/Present";
                            } else {
                              window.location.href =
                                arit + "/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(this.state.pathreturn + "/admission/Present");
                            }
                          });
                      }
                    });
                } else {
                  this.setState({ checkpaymoney: true });
                }
              } else {
                if (
                  res.data.data.data[0]["REGISTER_STATUS_BILL_ROBFULL_BOOK"] ||
                  res.data.data.data[0]["REGISTER_ID"] === "6708204012"
                ) {
                  localStorage.setItem("statusHeader", "1");
                  axios
                    .get(
                      admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]
                    )
                    .then((response) => {
                      if (response.data === 0) {
                        axios
                          .get(
                            arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = this.state.pathreturn + "/admission/Present";
                            } else {
                              window.location.href =
                                arit + "/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(this.state.pathreturn + "/admission/Present");
                            }
                          });
                      } else {
                        axios
                          .get(
                            arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = this.state.pathreturn + "/admission/Present";
                            } else {
                              window.location.href =
                                arit + "/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(this.state.pathreturn + "/admission/Present");
                            }
                          });
                      }
                    });
                } else if (res.data.data.data[0]["REGISTER_STATUS_BILL_ROB1_BOOK"]) {
                  if (res.data.data.data[0]["REGISTER_STATUS_BILL_ROB2_BOOK"]) {
                    localStorage.setItem("statusHeader", "1");
                    axios
                      .get(
                        admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]
                      )
                      .then((response) => {
                        if (response.data === 0) {
                          axios
                            .get(
                              arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                              this.state.citizent +
                              "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                            )
                            .then((checkdata) => {
                              if (checkdata.data.length !== 0) {
                                window.location.href = this.state.pathreturn + "/admission/Present";
                              } else {
                                window.location.href =
                                  arit + "/ap/account/?nu=pdpaAgree&code=" +
                                  btoa(this.state.citizent) +
                                  "&status=" +
                                  btoa(3) +
                                  "&url=" +
                                  btoa(window.location.origin + this.state.pathreturn + "/admission/Present");
                              }
                            });
                        } else {
                          axios
                            .get(
                              arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                              this.state.citizent +
                              "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                            )
                            .then((checkdata) => {
                              if (checkdata.data.length !== 0) {
                                window.location.href = this.state.pathreturn + "/admission/Present";
                              } else {
                                window.location.href =
                                  arit + "/ap/account/?nu=pdpaAgree&code=" +
                                  btoa(this.state.citizent) +
                                  "&status=" +
                                  btoa(3) +
                                  "&url=" +
                                  btoa(this.state.pathreturn + "/admission/Present");
                              }
                            });
                        }
                      });
                  } else {
                    this.setState({ checkpaymoney: true });
                  }
                } else {
                  this.setState({ checkpaymoney: true });
                }
              }
            }
          }
          // })
        } else {
          Swal.fire({
            icon: "info",
            title: "ไม่พบข้อมูลของ : " + citizent,
            text: "กรุณาตรวจสอบเลขบัตรประชาชน / Passport อีกครั้ง",
          });
        }
      });
  }

  checkpaymoney_close(event) {
    this.setState({ checkpaymoney: false });
  }
  checkpdpa(citizent) {
    localStorage.setItem("statusHeader", "1");
    // this.redirectToDataRegister("/Present");
    axios
      .get(
        arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
        citizent +
        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
      )
      .then((response) => {
        if (response.data.length !== 0) {
          Swal.fire({
            icon: "success",
            title: "ยินดีต้อนรับ",
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          }).then((res) => {
            this.redirectToDataRegister("/admission/Present");
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "ยินดีต้อนรับ",
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          }).then((res) => {
            window.location.href =
              arit + "/ap/account/?nu=pdpaAgree&code=" +
              btoa(this.state.citizent) +
              "&status=" +
              btoa(3) +
              "&url=" +
              btoa(this.state.pathreturn + "/admission/Present");
          });
        }
      });
  }
  submitpresent2025(event) {
    event.preventDefault();
    const citizent = this.state.citizent.replace("/", ",");
    this.setState({ load: true, citizent });
    localStorage.setItem("citizent", citizent);

    axios
      .get(mua + "/admissionnew2022/showlistregister?id=" + encodeURIComponent(citizent))
      .then((response) => {
        this.setState({ load: false });
        const nested = response?.data?.data;
        const data = Array.isArray(nested?.data)
          ? nested.data
          : Array.isArray(nested)
            ? nested
            : Array.isArray(response?.data)
              ? response.data
              : [];

        if (!data.length) {
          Swal.fire({
            icon: "info",
            title: "ไม่พบข้อมูลของ : " + citizent,
            text: "กรุณาตรวจสอบเลขบัตรประชาชน / Passport อีกครั้ง",
          });
          return;
        }

        localStorage.setItem("ID_LOGIN", data[0].ID_LOGIN);

        const datatrue = data.filter(
          ({ REGISTER_STATUS }) =>
            REGISTER_STATUS === "6" ||
            REGISTER_STATUS === "7" ||
            REGISTER_STATUS === "8" ||
            REGISTER_STATUS === "9"
        );

        if (datatrue.length === 0) {
          Swal.fire({
            icon: "info",
            title: "ยังไม่ถึงขั้นตอนรายงานตัว",
            text: "สถานะปัจจุบันยังไม่เปิดให้กรอกข้อมูลรายงานตัว",
          });
          return;
        }

        if (datatrue[0].REGISTER_STATUS_BILL_ROBFULL_BOOK !== null) {
          this.checkpdpa(citizent);
        } else if (
          (datatrue[0].REGISTER_STATUS_BILL_ROB1_BOOK !== null &&
            datatrue[0].REGISTER_STATUS_BILL_ROB2_BOOK !== null) ||
          (datatrue[0].REGISTER_STATUS_BILL_ROB1_BOOK !== null &&
            (datatrue[0].Major1_MAJOR_ID === "9903" ||
              datatrue[0].Major1_MAJOR_ID === "9901")) ||
          datatrue[0].Major1_MAJOR_ID === "8205"
        ) {
          this.checkpdpa(citizent);
        } else {
          Swal.fire({
            icon: "info",
            html: "<div style='display:flex;flex-direction:column;' ><div style='font-weight:500;font-size:20px;' >ชำระเงินค่าธรรมเนียมทางการศึกษายังไม่ครบถ้วน</div><div style='font-weight:300;font-size:16;'>ยังไม่สามารถกรอกข้อมูลรายงานตัวได้ กรุณาติดต่อ 055-706547</div> </div>",
          }).then(() => {
            localStorage.setItem("ID_LOGIN", data[0].ID_LOGIN);
          });
        }
      })
      .catch(() => {
        this.setState({ load: false });
        Swal.fire({
          icon: "error",
          title: "ไม่สามารถตรวจสอบได้ในขณะนี้",
          text: "กรุณาลองใหม่อีกครั้ง",
        });
      });
  }
  render() {
    const canSubmit = this.state.citizent.trim().length > 0 && !this.state.load;

    return (
      <>
        <MetaTags>
          <title>ข้อมูลรายงานตัว | มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="กรอกข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>

        <div className="check-page present-page">
          <div className="check-shell">
            <div className="check-hero">
              <p className="check-hero__eyebrow">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
              <h1 className="check-hero__title">
                <HiDocumentText size={28} aria-hidden />
                ข้อมูลรายงานตัว
              </h1>
              <p className="check-hero__desc">
                กรอกเลขบัตรประชาชนหรือ Passport เพื่อเริ่มกรอกข้อมูลรายงานตัวเข้าศึกษา
              </p>
            </div>

            <div className="check-panel">
              <form className="check-form" onSubmit={this.submitpresent2025}>
                <div className="check-field">
                  <label className="check-field__label" htmlFor="citizent">
                    รหัสเลขบัตรประชาชน / Passport
                  </label>
                  <p className="check-field__hint">
                    ใช้เลขเดียวกับที่สมัครเรียน · คนไทย 13 หลัก · ต่างชาติใช้ Passport
                  </p>
                  <input
                    type="text"
                    className="check-field__input"
                    id="citizent"
                    name="citizent"
                    placeholder="เช่น 1-2345-67890-12-3"
                    value={this.state.citizent}
                    onChange={this.handleChange}
                    autoComplete="off"
                    required
                  />
                </div>

                <button type="submit" className="check-submit" disabled={!canSubmit}>
                  <HiDocumentText size={20} aria-hidden />
                  {this.state.load ? "กำลังตรวจสอบ..." : "เริ่มกรอกข้อมูลรายงานตัว"}
                </button>
              </form>
            </div>

            <div className="check-tips">
              <p className="check-tips__title">ก่อนเริ่มกรอก</p>
              <ul className="check-tips__list">
                <li>
                  <HiOutlineBanknotes size={16} aria-hidden />
                  ชำระค่าธรรมเนียมการศึกษาให้ครบก่อนรายงานตัว
                </li>
                <li>
                  <HiOutlineDocumentDuplicate size={16} aria-hidden />
                  เตรียมเอกสารตามคู่มือด้านล่างให้พร้อม
                </li>
                <li>
                  <HiOutlinePhone size={16} aria-hidden />
                  หากมีปัญหาติดต่อ 055-706547
                </li>
              </ul>
            </div>
          </div>

          <div className="check-shell check-shell--wide">
            <section className="present-section" aria-label="วิดีโอตัวอย่าง">
              <h2 className="present-section__head">วิดีโอตัวอย่างขั้นตอนการกรอกข้อมูล</h2>
              <p className="present-section__desc">ดูตัวอย่างก่อนกรอกจริง จะช่วยให้ทำได้เร็วขึ้น</p>
              <div className="present-video">
                <iframe
                  src="https://www.youtube.com/embed/1y23AEUQW4w?si=Q7MVfkW_10qS3yDQ"
                  title="วิดีโอตัวอย่างขั้นตอนการกรอกข้อมูลรายงานตัว"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </section>

            <section className="present-guide" aria-label="คู่มือรายงานตัว">
              <h2 className="present-section__head">คู่มือขั้นตอนการรายงานตัว</h2>
              <p className="present-section__desc">เลื่อนดูภาพประกอบทีละขั้นตอน</p>
              <div className="present-guide__panel">
                <ul className="present-guide__list">
                  {PRESENT_GUIDE_IMAGES.map((src, index) => (
                    <li key={index}>
                      <img src={src} alt={`ขั้นตอนการรายงานตัว หน้า ${index + 1}`} />
                    </li>
                  ))}
                </ul>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }
}



